import React from "react";
import { useLocalization } from "@i18n";
import { GeneralDashboardCard } from "./GeneralDashboardCard";
import { GeneralDashboardFieldGrid, FieldItem } from "./GeneralDashboardFieldGrid";
import { GeneralDashboardGeneralData } from "../api/generalDashboard/generalDashboard.types";

interface GeneralGeneralDataCardProps {
  data: GeneralDashboardGeneralData | null;
  onMenuClick: () => void;
}

export const GeneralGeneralDataCard: React.FC<GeneralGeneralDataCardProps> = ({
  data,
  onMenuClick,
}) => {
  const { translate } = useLocalization();

  const coordinateSystemLabel = data?.centralPointCoordinateSystem
    ? translate(
        `admin.structures.generalData.coordinateSystem.${data.centralPointCoordinateSystem}`,
      )
    : null;

  const fields: FieldItem[] = [
    {
      labelKey: "general.dashboard.generalData.responsibleCompany",
      value: data?.responsibleCompany,
    },
    {
      labelKey: "general.dashboard.generalData.operationStartDate",
      value: data?.operationStartDate,
      isDate: true,
    },
    {
      labelKey: "general.dashboard.generalData.operationEndDate",
      value: data?.operationEndDate,
      isDate: true,
    },
    {
      labelKey: "general.dashboard.generalData.coordinateSystem",
      value: coordinateSystemLabel,
    },
  ];

  return (
    <GeneralDashboardCard
      title={translate("general.dashboard.generalData.title")}
      onMenuClick={onMenuClick}
    >
      <GeneralDashboardFieldGrid fields={fields} columns={4} variant="identity" />
    </GeneralDashboardCard>
  );
};
